var ContactPage = function() {
    var _template = 'contact';

    var _enableEventHandlers = function() {
        enableMap();

        $('.viewport').on('inview', function() {
            var $banner = $(this).find('.banner__wrap'),
                $headline = $(this).find('#headline'),
                $bodycopy = $(this).find('.bodycopy'),
                $form = $(this).find('.enquiry_panel');

            tm.to($banner, 0.4, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.2});
            tm.to($headline, 1, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.6});
            tm.to($bodycopy, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            tm.to($form, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            // tm.staggerTo($sharers, 0.5, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.4}, 0.2);
        });

        $('.enquiry_panel').on('inview', function() {
            tm.to($(this), 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
        });

        $('.case_studies_panel').on('inview', function() {
            tm.to($(this), 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 1});
        });

        $('.sidebar_free_quote').on('inview', function() {
            tm.to($(this), 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 1.2});
        });

        $(window).on("scroll resize", inview);
        setTimeout(inview, 1);
    };

    var _disableEventHandlers = function() {
        $('.viewport').off('inview', function() {
            var $banner = $(this).find('.banner__wrap'),
                $headline = $(this).find('#headline'),
                $bodycopy = $(this).find('.bodycopy'),
                $form = $(this).find('.enquiry_panel');

            tm.to($banner, 0.6, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.2});
            tm.to($headline, 1, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.6});
            tm.to($bodycopy, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            tm.to($form, 1, {y: 0, opacity: 1, ease: Circ.easeOut, delay: 0.8});
            // tm.staggerTo($sharers, 0.5, {x: 0, opacity: 1, ease: Circ.easeOut, delay: 0.4}, 0.2);
        });

        $(window).off("scroll resize", inview);
    };

    return {
        animateIn: function(callback) {
            if ($('.viewport').data('template') != _template) {
                return false;
            }

            _enableEventHandlers();

            tm.to($('.page-row-expanded'), 0.3, {css:{opacity: 1}, onComplete: function() {
                if (callback && typeof(callback) === "function") {
                    return(callback());
                }
            }});
        },
        animateOut: function(callback) {
            if ($('.viewport').data('template') != _template) {
                return false;
            }
            _disableEventHandlers();

            var $banner = $('.banner__wrap'),
                $headline = $('#headline'),
                $bodycopy = $('.bodycopy'),
                $form = $('.enquiry_panel');

            tm.to($form, 0.5, {y: 20, opacity: 0, ease: Circ.easeOut, delay: 0});
            tm.to($bodycopy, 0.5, {y: 60, opacity: 0, ease: Circ.easeOut, delay: 0});
            tm.to($headline, 1, {x: -30, opacity: 0, ease: Circ.easeOut, delay: 0.1});
            tm.to($banner, 0.3, {y: -20, opacity: 0, ease: Circ.easeOut, delay: 0.1, onComplete: function() {
                tm.to($('.page-row-expanded'), 0.1, {css:{opacity: 0}, onComplete: function() {
                    if (callback && typeof(callback) === "function") {
                        return(callback());
                    }
                }});
            }});
        }
    };
}();


var enableMap = function() {
    var $mapCanvas = $('#map');
    if ($mapCanvas.length) {
        if (typeof google === 'object' && typeof google.maps === 'object') {
            initMap();
        } else {
            loadMapsScript();
        }
    }
};

function loadMapsScript() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCrKZtJ0HJgdt7E4NsZ2bsiYffW8DIwHd0&callback=initMap';
    document.body.appendChild(script);
}

function initMap() {

    $mapCanvas = $('#map');

    var myLatlng = new google.maps.LatLng($mapCanvas.data('lat'), $mapCanvas.data('lng'));
    var mapOptions = {
        zoom: 15,
        zoomControl: true,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        panControl: false,
        backgroundColor: '#83918f',
        streetViewControl: false,
        scaleControl: false,
        scrollwheel: false,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.RIGHT_TOP
        }
    };

    google.maps.visualRefresh = true;

    var map = new google.maps.Map($mapCanvas.get(0), mapOptions);

    var contentString = '<div id="info-window-content">'+
        '<div class="info-window-title">НИКОМ СЕКЮРИТИ</div>'+
        '<div>' + $mapCanvas.data('address') + '</div>' +
        '</div>';

    var infowindow = new google.maps.InfoWindow({
        content: contentString
    });

    var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        title: 'НИКОМ СЕКЮРИТИ'
    });

    google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
    });

    $(window).on('resize', function() {
        map.setCenter(myLatlng);
    });
}
